const cce = {
  MICRO_DEPOSIT_NOT_ALLOWED: {
    message: 'Micro deposit is not allowed for your account'
  },
  MICRO_DEPOSIT_VALUE_NOT_ALLOWED: {
    message: 'Specify the micro deposit value is not allowed for your account'
  }
};

module.exports = cce;
